import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserService, ContextService, SigninService, CartService, CommandeService } from '../../shared';
import { User, Etablissement, Pays } from '../../shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

  @ViewChild('facToLiv') check;
  
  currentUser: User;
  temp: User;
  fac: any = {};
  liv: any = {};
  temp_mail: string;
  etablissements: Array<Etablissement> = [];
  pays: Array<Pays>;
  addressForm: FormGroup;
  etablissement_fac: string;
  etablissement_liv: string;
  context: string;

  constructor(
  	private userService: UserService,
    private contextService: ContextService,
    private commandeService: CommandeService,
    private cartService: CartService,
    private formBuilder: FormBuilder,
    private signInService: SigninService,
    private router: Router,
    // private cdr: ChangeDetectorRef,
  ) {
    
    this.context = this.contextService.getContext();
    let value:any;
    this.userService.currentUser.subscribe(
      data => {

    this.currentUser = data;
    this.fac = data;
    this.liv = data;
    

    if(this.context == 'B2B'){

      if(this.currentUser.typeUtilisateur != 204){
       if(data.uai)  this.signInService.checkUAI(data.uai[0])
          .subscribe(
            data => {

              this.etablissement_fac = data.nom; 
              this.etablissement_liv = data.nom; 
              this.fac.adresseEt = data.adresse1;
              this.fac.adresse2Et = data.adresse2;
              this.fac.codePostalEt = data.codePostal;
              this.fac.villeEt = data.ville;
              this.fac.paysEt = data.idPays;
              this.liv.adresseEt = data.adresse1;
              this.liv.adresse2Et = data.adresse2;
              this.liv.codePostalEt = data.codePostal;
              this.liv.villeEt = data.ville;
              this.liv.paysEt = data.idPays;
            }
          );
        this.addressForm = formBuilder.group({
          ad_fac: ['', Validators.compose([Validators.required])],
          ad2_fac: [''],
          zip_fac: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9a-zA-Z ]+$')])],
          ville_fac: ['', Validators.compose([Validators.required])],
          pays_fac: [null, Validators.compose([Validators.required])],
          et_fac: ['', Validators.compose([Validators.required])],
          check_fac: [false],
          name_liv: [''],
          fname_liv: [''],
          email_liv: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.][a-zA-Z0-9-.]+$')])],
          ad_liv: ['', Validators.compose([Validators.required])],
          ad2_liv: [''],
          ad3_liv: [''],
          zip_liv: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9a-zA-Z ]+$')])],
          ville_liv: ['', Validators.compose([Validators.required])],
          pays_liv: [null, Validators.compose([Validators.required])],
          et_liv: ['']
        });
      } else {
        this.currentUser.uai.forEach( function (uai){
          this.signInService.checkUAI(uai)
            .subscribe(
              data => {
               this.etablissements.push(data);
                this.fac.adresseEt = data.adresse1;
                this.fac.adresse2Et = data.adresse2;
                this.fac.codePostalEt = data.codePostal;
                this.fac.villeEt = data.ville;
                this.fac.paysEt = data.idPays;
                this.etablissement_fac= data.nom;
                this.etablissement_liv=uai;
      
              }
            );
        }, this)
        this.addressForm = formBuilder.group({
          ad_fac: ['', Validators.compose([Validators.required])],
          ad2_fac: [''],
          zip_fac: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9a-zA-Z ]+$')])],
          ville_fac: ['', Validators.compose([Validators.required])],
          pays_fac: [null, Validators.compose([Validators.required])],
          et_fac: ['', Validators.compose([Validators.required])],
          check_fac: [false],
          name_liv: [''],
          fname_liv: [''],
          email_liv: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.][a-zA-Z0-9-.]+$')])],
          ad_liv: ['', Validators.compose([Validators.required])],
          ad2_liv: [''],
          ad3_liv: [''],
          zip_liv: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9a-zA-Z ]+$')])],
          ville_liv: ['', Validators.compose([Validators.required])],
          pays_liv: [null, Validators.compose([Validators.required])],
          et_list_liv: ['', Validators.compose([Validators.required])],
        });
      }
    } else {
      this.addressForm = formBuilder.group({
        ad_fac: ['', Validators.compose([Validators.required])],
        ad2_fac: [''],
        zip_fac: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9a-zA-Z ]+$')])],
        ville_fac: ['', Validators.compose([Validators.required])],
        pays_fac: [null, Validators.compose([Validators.required])],
        name_liv: [''],
        fname_liv: [''],
        email_liv: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.][a-zA-Z0-9-.]+$')])],
      });
    }

  });

  }

  ngOnInit() {

    // this.userService.currentUser.subscribe(
    //   data => {

        // this.currentUser = data;
        // this.fac = data;
        // this.liv = data;
        // console.log(data)

        // if(data.uai){
        //   data.uai.forEach(function(et){
        //     this.signInService.checkUAI(et)
        //       .subscribe(etablissement => {
        //         this.etablissements.push(etablissement);
        //       });
        //   }, this);
        // }
        
    //   }
    // );

    if(this.context == 'B2B'){
      this.signInService.getAllPays()
        .subscribe(pays => {
          this.pays = pays;
        });
    } else {
      this.signInService.getFrancePays()
        .subscribe(pays => {
          this.pays = pays;
        });
    }

  }

  // ngAfterViewInit(){
  //   this.cdr.detectChanges();
  // }

  onSubmit(){
 

    this.liv.email=this.temp_mail;
    // console.log(this.temp_mail)

    sessionStorage.setItem("fac_hachette_kne", JSON.stringify(this.fac));
    sessionStorage.setItem("liv_hachette_kne", JSON.stringify(this.liv));
    // console.log(this.liv)

    // if(this.panier.montantTotal == 0){

    //   let preuves = JSON.parse(sessionStorage.getItem('preuveachat_kne'));

    //   let body: any = {};
    //   let commande: any = {};
    //   let req: any = {};
    //   body.adresseFacturation = {}; 
    //   body.adresseLivraison = {};
    //   body.preuvesAchat = preuves.preuvesAchat;
    //   body.preuvesAchatPapier = preuves.preuvesAchatPapier;
    //   body.adresseLivraison.email = this.liv.email;

    //   if(this.context == 'B2B'){
    //     if(this.currentUser.typeUtilisateur == 302){
    //       body.adresseFacturation.adresse1 = this.fac.adresse1;
    //       body.adresseFacturation.adresse2 = this.fac.adresse2;
    //       body.adresseFacturation.ville = this.fac.ville;
    //       body.adresseFacturation.idPaysLPC = this.fac.idPaysLPC;
    //       body.adresseFacturation.codePostal = this.fac.codePostalEt;
    //       body.adresseLivraison.adresse1 = this.liv.adresseEt;
    //       body.adresseLivraison.adresse2 = this.liv.adresse2Et;
    //       body.adresseLivraison.ville = this.liv.villeEt;
    //       body.adresseLivraison.idPaysLPC = +this.liv.paysEt;
    //       body.adresseLivraison.codePostal = this.liv.codePostal;
    //     } else {
    //       body.adresseFacturation.adresse1 = this.fac.adresseEt;
    //       body.adresseFacturation.adresse2 = this.fac.adresse2Et;
    //       body.adresseFacturation.ville = this.fac.villeEt;
    //       body.adresseFacturation.idPaysLPC = +this.fac.paysEt;
    //       body.adresseFacturation.codePostal = this.fac.codePostalEt;
    //       body.adresseLivraison.adresse1 = this.liv.adresse1;
    //       body.adresseLivraison.adresse2 = this.liv.adresse2;
    //       body.adresseLivraison.ville = this.liv.ville;
    //       body.adresseLivraison.idPaysLPC = this.liv.idPaysLPC;
    //       body.adresseLivraison.codePostal = this.liv.codePostal;
    //     }
    //   } else {
    //     body.adresseFacturation.adresse1 = this.fac.adresse1;
    //     body.adresseFacturation.adresse2 = this.fac.adresse2;
    //     body.adresseFacturation.ville = this.fac.ville;
    //     body.adresseFacturation.idPaysLPC = this.fac.idPaysLPC;
    //     body.adresseFacturation.codePostal = this.fac.codePostal;
    //     body.adresseLivraison.adresse1 = this.fac.adresse1;
    //     body.adresseLivraison.adresse2 = this.fac.adresse2;
    //     body.adresseLivraison.ville = this.fac.ville;
    //     body.adresseLivraison.idPaysLPC = this.fac.idPaysLPC;
    //     body.adresseLivraison.codePostal = this.fac.codePostal;
    //   }

    //   this.commandeService.validateCart(body).subscribe(
    //     data => {
    //       //console.log(data)
    //       commande = data;
    //       req.codeKNE = data.codeKNE;
    //       sessionStorage.setItem("commande_hachette_kne", JSON.stringify(data));

    //       if(data.montantTotal==0){
    //            if(this.context == 'B2B'){
    //              this.commandeService.payCart({codeKNE: commande.codeKNE, idModeReglement: 5}).subscribe(
    //                   data => {
                   
    //                       if(this.context == 'B2B') this.router.navigate(['/confirmation']);
    //                       if(this.context == 'B2C') this.router.navigate(['/familles/confirmation']);
    //                   },
    //                   error => alert(error.Message)
    //                 );
    //             } 
    //       }
    //     },
    //     error =>{
    //        alert(error[0].Message);
    //     }
    //   );

    // } else {
      if(this.context == 'B2B'){
        this.router.navigate(['/paiement']);
      } else {
        this.router.navigate(['/familles/paiement']);
      }
    // }

  }

  toggleLivraison(){

    if(this.check.nativeElement.checked){
      // console.log('yeah')
      this.temp = this.liv;
      this.liv = this.fac;
    } else {
      // console.log('nope')
      this.liv = this.temp;
    }

    // console.log(this.liv)
  }

}



// WEBPACK FOOTER //
// ./src/app/user/_address/address.component.ts